import { render, staticRenderFns } from "./appointment-unpaid.vue?vue&type=template&id=db46cd78&scoped=true&"
import script from "./appointment-unpaid.vue?vue&type=script&lang=js&"
export * from "./appointment-unpaid.vue?vue&type=script&lang=js&"
import style0 from "./appointment-unpaid.vue?vue&type=style&index=0&id=db46cd78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db46cd78",
  null
  
)

export default component.exports